import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Container, Alert } from 'react-bootstrap';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

/**
 * Container for case when tenant id not available
 */
const missingTenantId = () => {
  return (
    <>
      <Header title={<FormattedMessage id="header.missingTenantId.title" />} />
      <Container id="main">
        <div>
          <Alert variant="danger">
            <FormattedMessage id="error.missingTenantId" />
          </Alert>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default missingTenantId;
